module.exports = __webpack_public_path__ + "img/imprint-missing.83dc0712.png";